module.exports = __webpack_public_path__ + "img/heute.bee8ecd1.png";